module.exports = __webpack_public_path__ + "media/Goat2.9a54e1fc.ogg";